export class ListThreatHuntingResultsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "requestId",
            "baseName": "requestId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ListThreatHuntingResultsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
